module.exports = __webpack_public_path__ + "img/追溯管理类.c893074d.png";